(() => {
    if (sessionStorage.reloaded) {
        return;
    }

    let previous;
    try {
        previous = new URL(sessionStorage.previous)
    } catch (err) {
        return;
    }
    if (previous.origin !== location.origin) {
        return;
    }

    const back_button = document.querySelector('a.page-header-back-link[data-history]');
    if (!back_button) {
        return;
    }

    const href = back_button.href;

    back_button.onclick = (e) => {
        e.preventDefault();

        window.history.back()
        setTimeout(() => {
            window.open(href, '_top');
        }, 500);
    };
})();
